var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.3835,
    stroke: "#FEFEFE",
    strokeWidth: 1.23298
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2758 10.4589C25.4322 10.4712 25.5675 10.4835 25.6782 10.4944L25.6062 13.3915C25.5019 13.3907 25.3789 13.3898 25.2412 13.3889C24.7897 13.386 24.1787 13.3831 23.5409 13.3831C22.8033 13.3831 22.2545 13.5552 21.9197 13.9897C21.6056 14.3975 21.5571 14.9483 21.5571 15.4847V18.322V18.7067H21.9418H25.688L25.5432 21.823H21.9418H21.5571V22.2077V32.6153H18.2837V22.2077V21.823H17.899H15.4756V18.7067H17.899H18.2837V18.322V15.0031C18.2837 13.7787 18.6724 12.6305 19.4829 11.7907C20.2895 10.9548 21.5522 10.3847 23.3798 10.3847C24.1414 10.3847 24.804 10.4218 25.2758 10.4589Z",
    fill: "#FEFEFE",
    stroke: "#FEFEFE",
    strokeWidth: 0.769376
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3382fe5f5880b467bfd4cdbec9eb23da.svg";
export { ForwardRef as ReactComponent };